/**
 * @file Purchase Album Photos Checkout Success component.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PurchaseAlbumHeaderContainer from '../../containers/purchase/PurchaseAlbumHeaderContainer';
import ContentWrap from '../global/ContentWrap';
import Button from '../global/Button';
import { getAsset } from '../../util/assets';

class PurchaseAlbumPhotosCheckoutSuccess extends Component {
  static propTypes = {
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    purchasedUrl: PropTypes.string,
    loading: PropTypes.bool,
  };

  render() {
    const { album, purchasedUrl, loading } = this.props;

    if (loading) {
      return null;
    }

    return (
      <div className="wrapper-main content-wrap-gray">
        <PurchaseAlbumHeaderContainer album={album} />

        <div className="content-wrap-escape">
          <ContentWrap>
            <div className="text-center">
              <img
                src={getAsset('/raised-hands.svg')}
                width="160"
                alt=""
                className="mb-2"
              />

              <h3 className="mb-2">Thank you for your purchase!</h3>

              <p className="text-dark mb-4">
                To view and download your photos press the following button:
              </p>

              <Button href={purchasedUrl} btnBlock>
                View your purchased photos
              </Button>
            </div>
          </ContentWrap>
        </div>
      </div>
    );
  }
}

export default PurchaseAlbumPhotosCheckoutSuccess;
